export interface IVersionedObject<Content> {
    version: string;
    versionDateTime: Date;
	deletionTime: string; //Date
	creationUser: string;
    content: (Content);
}

export interface ICompanyContent {
	id: string;
	name: string;
	description: string;
    companyName: string;
    companyCvr: string;
    companyAddress: string;
    companyPhoneNumber: string;
    companyAdminIds: string[];
}

export interface IOfficeContent {
	id: string;
	name: string;
	description: string;
    companyId: string;
    officeName: string;
    officeAddress: string;
    officeAdminIds: string[];
    defaultSeatings: IDefaultSeatingContent[]
    defaultAvailability: IDefaultAvailabilityContent []
    defaultDishesContent: IDefaultDishContent []
    officeSettings: IOfficeContentSettings | undefined;
}

export interface IOfficeContentSettings {
    canCommentOnBookings: boolean
}

export interface IDefaultSeatingContent {
    defaultSeatingId: string
    defaultSeatingName:string;
    defaultSeatingStartTime:string;
    defaultSeatingEndTime:string;
    defaultSeatingCapacity:number;
    defaultSeatingDishes:string[];
    defaultSeatingPriceModelId: string;
}

export interface IDefaultAvailabilityContent {
    weekDay:string;
    available:boolean;
}

export interface IDefaultDishContent {
    defaultDishId: string;
    defaultDishName: string;
    defaultDishDescription: string;
    defaultDishFoodCategories: string[];
    defaultDishAllergens: string[]
}


export interface IEaterGroupContent {
	id: string;
	name: string;
	description: string;
    officeId: string;
    eaterGroupName: string;
    eaterGroupCVR: string;
    eaterGroupAddress:string;
    eaterGroupPhoneNumber: string;
    eaterGroupAdminIds: string[];
}


export interface IUserContent {
	id: string;
	name: string;
	description: string;
    applicationUserId: string;
    officeId: string;
    eaterGroupId: string;
}


export interface ISeatingContent {
	id: string;
	name: string;
	description: string;
    officeId: string;
    seatingName: string;
    seatingStart: string; //Date
    seatingEnd: string; //Date
    seatingCapacity: number;
    seatingDishes: ISeatingDishContent[];
    priceModelId: string;
    priceModelVersion: string;
}


export interface ISeatingDishContent {
    dishId: string;
    menuQuantity: number;
}

export interface IBookingContent {
	id: string;
	name: string;
	description: string;
    userId: string;
    seatingId: string;
    seatingVersion: string;
    bookingPricePerServing: number;
    bookingItems: IBookingItemContent[];
    bookingComment: string;
}

export interface IBookingItemContent {
    bookingItemId: string;
    dishId: string;
    dishVersion: string;
    checkInTime ?: string;
}


export interface IDishContent {
	id: string;
	name: string;
	description: string;
    officeId: string;
    dishTitle: string;
    dishDescription: string;
    foodCategories: string[];
    allergens: string[];
    co2Impact: string;      
}

export interface ICountdown {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export interface IPriceModelContent {
	id: string;
	name: string;
	description: string;
    officeId: string;
    priceModelType: string;
    priceModelParameters: string;
}

export interface IReverseDutchAuctionPriceModelParameters {
    cutOffTimeADay: string;
    cutOffDaysBefore: number;
    pricePoints: ReverseDutchAuctionPriceModelParametersPricePoint[];
}

export interface ReverseDutchAuctionPriceModelParametersPricePoint {
    cutOffHour: number;
    price: number;
}

export interface IConstantAuctionParameters {
    cutOffTimeADay: string;
    cutOffDaysBefore: number;
    price: number;
}

export enum PriceModelTypes {
    REVERSE_DUTCH_AUCTION = "REVERSE_DUTCH_AUCTION",
    CONSTANT_AUCTION = "CONSTANT_AUCTION"
}


